import "./App.css";
import React, { useState, useEffect } from "react";
import { Route, Routes, useSearchParams, useNavigate } from "react-router-dom";
import SplashScreen from "./page/SplashScreen/SplashScreen";
import CancelApplication from "./page/CancelApplication/CancelApplication";
import ApplicationRouter from "./page/ApplicationRouter/ApplicationRouter";
import CampaignService from "./service/CampaignService";
import CancelComplete from "./page/CancelComplete/CancelComplete";
import ErrorAlter from "./page/ErrorAlter/ErrorAlter";
import CallRequestComplete from "./page/CallRequestComplete/CallRequestComplete";
import EventCalendar from "./page/EventCalendar/EventCalendar";
import EventDetailView from "./page/EventCalendar/EventDetailView";
import ExternalProductList from "./page/WebDirectReservation/components/ExternalProductList";
import CustomerInformation from "./page/CustomerInformation/CustomerInformation";
import BookingInformation from "./page/CustomerInformation/BookingInformation";
import EventCalendar2 from "./page/EventCalendar/EventCalendar2";

function App() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState(null); //["11", "12", "13", "14", "15", "16", "17", "18", "19", "20"
  const [kind, setKind] = useState(null);
  const [customerNo, setCustomerNo] = useState(null);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [searchParams] = useSearchParams();

  const [orderNo, setOrderNo] = useState(null);
  const [salesNo, setSalesNo] = useState(null);
  const [orderKey, setOrderKey] = useState(null);

  const OrderInfo = async (orderNo, salesNo, orderKey) => {
    try {
      const result = await CampaignService.orderInfo(
        orderNo,
        salesNo,
        orderKey
      );

      if (result) {
        navigate("/booking", {
          state: {
            orderNo,
            salesNo,
            orderKey,
          },
        });
      } else {
        navigate(`/error`);
      }
    } catch (error) {
      navigate(`/error`);
    } finally {
    }
  };

  const fetchInfo = async (_kind, _customerNo, _code) => {
    try {
      const result = await CampaignService.customerInfo(
        _kind,
        _customerNo,
        _code
      );

      //console.log("result", result);

      if (result.Info) {
        setCustomerInfo(result.Info[0]);

        //상담요청 페이지인데 상태가  상담요청으로 등록되어 있으면
        if (_kind === "2" && result.Info[0].상태 === "384100") {
          navigate("/callRequestComplete", {
            state: {
              selectedDate: result.Info[0].상담지정날짜,
              selectedTime: result.Info[0].상담지정시간,
            },
          });
        } else if (_kind === "1" && result.Info[0].상태 === "384102") {
          //취소요청 페이지인데 상태가  취소요청으로 등록되어 있으면
          navigate("/cancelcomplete");
        }
      } else {
        navigate(`/error`);
      }
    } catch (error) {
      navigate(`/error`);
    } finally {
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // 3초 후에 로딩 상태를 false로 설정

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const _kind = searchParams.get("kind");
      const _customerNo = searchParams.get("customerNo");
      const _code = searchParams.get("code");

      const _orderNo = searchParams.get("orderNo");
      const _salesNo = searchParams.get("salesNo");
      const _orderKey = searchParams.get("orderKey");

      setKind(_kind);
      setCustomerNo(_customerNo);
      setCode(_code);

      setOrderNo(_orderNo);
      setSalesNo(_salesNo);
      setOrderKey(_orderKey);

      if (_kind !== null && _customerNo !== null && _code !== null) {
        await fetchInfo(_kind, _customerNo, _code);
      } else if (_orderNo !== null && _salesNo !== null && _orderKey !== null) {
       
        await OrderInfo(_orderNo, _salesNo, _orderKey);
      }
    };

    fetchData();
  }, [searchParams]);

  return (
    <div className="App">
      {/* <Route path="/" element={<CancelApplication />} /> */}

      {loading ? (
        <SplashScreen customerInfo={customerInfo} />
      ) : (
        <Routes>
          {/* <Route path="/:kind/:customerNo" element={<ApplicationRouter customerInfo={customerInfo} />} /> */}
          <Route
            path="/"
            element={
              <ApplicationRouter
                kind={kind}
                customerNo={customerNo}
                code={code}
                customerInfo={customerInfo}
              />
            }
          />

          <Route path="/cancelcomplete" element={<CancelComplete />} />
          <Route
            path="/callRequestComplete"
            element={<CallRequestComplete />}
          />
          <Route path="/error" element={<ErrorAlter />} />

          <Route path="/Event" element={<EventCalendar />} />

          <Route path="/EventDetail" element={<EventCalendar2 />} />

          <Route path="/EventDetailView" element={<EventDetailView />} />

          <Route
            path="/ExternalProductList"
            element={<ExternalProductList />}
          />

          <Route path="/customer" element={<CustomerInformation />} />
          <Route path="/booking" element={<BookingInformation />} />

          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                {" "}
                <div className="flex items-center justify-center h-screen">
                  {" "}
                  <div className="flex-col space-y-4 text-center">
                    {" "}
                    {/* <div class="text-fuchsia-600 text-xl font-medium">Tailblocks</div>  */}
                    <div className="text-4xl font-medium">Page not found</div>{" "}
                    <div class="text-gray-500">
                      Sorry, the page you're looking for isn't available.
                    </div>{" "}
                    <div className="flex items-center justify-center">
                      {" "}
                      {/* <div
                        className="bg-blue-600 px-4 py-2 text-white font-medium rounded-lg hover:scale-105 cursor-pointer"
                        //  onClick={handleHome}
                      >
                        홈으로 이동
                      </div> */}{" "}
                    </div>{" "}
                  </div>{" "}
                </div>{" "}
                {/* window.location.href = "/auth"; // 원하는 URL로 변경하세요. */}
              </main>
            }
          />
        </Routes>
      )}

      {/* <div className="App">{loading ? <SplashScreen /> : <CancelApplication />}</div>; */}
    </div>
  );
}

export default App;
